/**
 * A escolha da profissao em DOIS passos: a profissao, e depois a especialidade.
 *
 * O catalogo virou dois niveis em 18/09/2026, quando o P.O. respondeu que o produto
 * atende medicos, personal trainer e fisiologistas. As 55 linhas que existiam nunca foram
 * profissoes - sao as especialidades medicas do CFM -, e pendura-las ao lado de "Personal
 * trainer" numa lista so faria o campo responder duas perguntas ao mesmo tempo.
 *
 * Mora fora dos dois apresentadores porque os DOIS fazem esta escolha: o formulario de
 * cadastro e a ficha de edicao. Escrita duas vezes, ela divergiria no primeiro ajuste.
 *
 * ## O que ela decide
 *
 * - `professionalTypeId` - o que vai para o servidor. E a ESPECIALIDADE quando a profissao
 *   tem uma; a propria profissao quando nao tem (personal trainer, fisiologista). Os dois
 *   sao linhas da mesma tabela, entao o contrato nao mudou.
 * - `regulated` - vem da PROFISSAO, porque e la que mora o conselho. A especialidade herda.
 */
export class ProfessionalTypeChoice {
    constructor() {
        this.todos = [];
    }
    receive(todos) {
        this.todos = todos;
    }
    /** As profissoes: as linhas sem pai. */
    get professions() {
        return this.todos.filter((tipo) => tipo.parentId == null);
    }
    /** As especialidades da profissao escolhida. Vazio quando ela nao tem. */
    get specialties() {
        if (this.professionId == null) {
            return [];
        }
        return this.todos.filter((tipo) => tipo.parentId === this.professionId);
    }
    get chosenProfession() {
        return this.todos.find((tipo) => tipo.id === this.professionId);
    }
    get chosenSpecialty() {
        return this.todos.find((tipo) => tipo.id === this.specialtyId);
    }
    /** O conselho e da profissao; sem profissao escolhida nao ha registro a pedir. */
    get regulated() {
        return this.chosenProfession?.regulated ?? false;
    }
    /**
     * Se ainda falta escolher a especialidade.
     *
     * Escolher "Medico" e parar ali deixaria o vinculo apontando para a profissao, e a
     * tela de colaboradores mostraria "Medico" onde ela mostra "Cardiologia" hoje.
     */
    get missingSpecialty() {
        return this.specialties.length > 0 && this.specialtyId == null;
    }
    /** O que vai para o servidor. */
    get professionalTypeId() {
        return this.specialtyId ?? this.professionId;
    }
    chooseProfession(id) {
        if (this.professionId === id) {
            return;
        }
        this.professionId = id;
        this.specialtyId = undefined;
    }
    chooseSpecialty(id) {
        this.specialtyId = id;
    }
    /** Desfaz tudo - a especialidade nao sobrevive a troca da profissao. */
    clear() {
        this.professionId = undefined;
        this.specialtyId = undefined;
    }
    clearSpecialty() {
        this.specialtyId = undefined;
    }
    /**
     * Reconstroi a escolha a partir do que o servidor guardou.
     *
     * O vinculo guarda UM id, que pode ser de qualquer um dos dois niveis: se ele tem pai,
     * e especialidade e a profissao vem do pai; se nao tem, e a propria profissao.
     */
    restore(professionalTypeId) {
        this.clear();
        if (professionalTypeId == null) {
            return;
        }
        const tipo = this.todos.find((candidato) => candidato.id === professionalTypeId);
        if (!tipo) {
            return;
        }
        if (tipo.parentId == null) {
            this.professionId = tipo.id;
        }
        else {
            this.professionId = tipo.parentId;
            this.specialtyId = tipo.id;
        }
    }
}
//# sourceMappingURL=professional-type-choice.js.map